import React from 'react';
import { ScanRule } from '../types/scan_rule/scanRule';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface ScanRuleContextProps {
  scanRules: Map<string, ScanRule>;
  setScanRules: (ScanRule: Map<string, ScanRule>) => void;
  scanRulesLoading: boolean;
}

const defaultContext: ScanRuleContextProps = {
  scanRules: new Map(),
  setScanRules: () => {},
  scanRulesLoading: false,
};

export const ScanRuleContext = React.createContext<ScanRuleContextProps>(defaultContext);

interface ScanRuleState {
  items: Record<string, any>[];
  loading: boolean;
}

export const scanRuleSlice = createSlice({
  name: 'scanRule',
  initialState: { items: [], loading: true } as ScanRuleState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<ScanRule[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<ScanRule[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
